import { createStore } from 'satcheljs';
import type { AssetId } from 'owa-timestream-types';

export default createStore('assetSdkResizeStore', {
    assetResizing: null as AssetId | null,
    shouldShowResizeHandles: false,
    assetResizingParent: {
        widestChildSize: null as number | null,
        isResizingWidestChild: false,
        initialPosition: {
            x: null as number | null,
            y: null as number | null,
        },
    },
});
